import { gql, useMutation } from '@apollo/client';

import type { DeleteResidenceMutation, DeleteResidenceMutationVariables } from './__generated__/useDeleteResidence.gql';

const DELETE_RESIDENCE = gql`
  mutation DeleteResidence($input: DeleteResidenceInput!) {
    deleteResidence(input: $input)
  }
`;

/**
 * Delete a `Residence` from the viewer's family. Returns the deleted row's id
 * on success or `null` if the row wasn't in the viewer's family — the
 * controller's `deleteById` returns `null` on no-match and `SqlValidator`
 * filters foreign rows out.
 */
export const useDeleteResidence = () => {
  return useMutation<DeleteResidenceMutation, DeleteResidenceMutationVariables>(DELETE_RESIDENCE);
};
